import { useLang } from "@/lib/i18n";

export default function HowItWorks() {
  const { t } = useLang();
  return (
    <section className="max-w-7xl mx-auto px-5 sm:px-10 py-24" data-testid="how-section">
      <h2 className="font-display text-4xl sm:text-5xl mb-14">{t.how_title}</h2>
      <ol className="grid md:grid-cols-3 gap-px bg-white/10 border border-white/10">
        {t.how.map(([title, body], i) => (
          <li key={title} className="bg-[#050B14] p-8 sm:p-10 hover:bg-[#0A1325] transition-colors duration-300">
            <span className="font-display text-6xl text-[#D4AF37]/70">0{i + 1}</span>
            <h3 className="text-lg font-medium mt-4 mb-2">{title}</h3>
            <p className="text-slate-400 text-sm leading-relaxed">{body}</p>
          </li>
        ))}
      </ol>
    </section>
  );
}
